import NavBar from "../../../components/organisms/navbar";
import { useParams } from "react-router-dom";
import Confetti from "react-confetti";
import { useEffect, useState } from "react";
import { FaInstagram, FaCheckCircle, FaClipboardList } from "react-icons/fa";
import logoTorneioFacil from "../../../assets/images/branding/logo-torneiofacil.png";

const PaymentEnrollmentICampeonatoAmazonenseDeMmaAmador2026 = () => {
    const { slug, id } = useParams();

    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [confettiPieces, setConfettiPieces] = useState(300);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener("resize", handleResize);

        const interval = setInterval(() => {
            setConfettiPieces((prev) => {
                if (prev <= 0) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 15;
            });
        }, 300);

        return () => {
            window.removeEventListener("resize", handleResize);
            clearInterval(interval);
        };
    }, []);

    const colors = {
        bgDark: "#0b0f2b",
        bgCard: "#111640",
        bgCardLight: "#1a2055",
        red: "#e63946",
        redLight: "#ff4d5a",
        white: "#ffffff",
        gray: "#a0a8c8",
        border: "#2a3070",
        greenSuccess: "#00c853",
    };

    return (
        <div style={{ background: colors.bgDark, minHeight: "100vh" }}>
            <NavBar />
            {confettiPieces > 0 && (
                <Confetti
                    width={windowSize.width}
                    height={windowSize.height}
                    numberOfPieces={confettiPieces}
                    colors={[colors.red, colors.white, "#1a1f6e", "#ff6b6b", "#4dabf7"]}
                />
            )}

            <div style={{
                maxWidth: "600px",
                margin: "0 auto",
                padding: "40px 20px 60px",
            }}>
                {/* Logo */}
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                    <img
                        src={logoTorneioFacil}
                        alt="Torneio Fácil"
                        style={{ height: "50px", objectFit: "contain" }}
                    />
                </div>

                {/* Card Principal */}
                <div style={{
                    background: colors.bgCard,
                    borderRadius: "16px",
                    border: `1px solid ${colors.border}`,
                    overflow: "hidden",
                }}>
                    {/* Header verde com check */}
                    <div style={{
                        background: "linear-gradient(135deg, #00c853 0%, #00a844 100%)",
                        padding: "24px 20px",
                        textAlign: "center",
                    }}>
                        <FaCheckCircle size={40} color={colors.white} style={{ marginBottom: "10px" }} />
                        <h1 style={{
                            color: colors.white,
                            fontSize: "1.35rem",
                            fontWeight: 800,
                            margin: 0,
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                        }}>
                            Inscricao Confirmada!
                        </h1>
                    </div>

                    {/* Corpo */}
                    <div style={{ padding: "24px 20px" }}>
                        {/* Nome do Torneio */}
                        <div style={{
                            textAlign: "center",
                            marginBottom: "20px",
                        }}>
                            <p style={{
                                color: colors.gray,
                                fontSize: "0.8rem",
                                margin: "0 0 6px 0",
                                textTransform: "uppercase",
                                letterSpacing: "2px",
                            }}>
                                Voce se inscreveu no
                            </p>
                            <h2 style={{
                                color: colors.white,
                                fontSize: "1.15rem",
                                fontWeight: 800,
                                fontStyle: "italic",
                                margin: 0,
                                textTransform: "uppercase",
                                lineHeight: 1.3,
                            }}>
                                I Campeonato Amazonense de MMA Amador 2026
                            </h2>
                        </div>

                        {/* Numero da Inscricao */}
                        <div style={{
                            background: `linear-gradient(135deg, ${colors.red} 0%, #c62828 100%)`,
                            borderRadius: "10px",
                            padding: "12px",
                            textAlign: "center",
                            marginBottom: "24px",
                        }}>
                            <p style={{
                                color: "rgba(255,255,255,0.8)",
                                fontSize: "0.7rem",
                                margin: "0 0 2px 0",
                                textTransform: "uppercase",
                                letterSpacing: "2px",
                            }}>
                                Inscricao N°
                            </p>
                            <p style={{
                                color: colors.white,
                                fontSize: "1.7rem",
                                fontWeight: 900,
                                margin: 0,
                                fontStyle: "italic",
                            }}>
                                {id}
                            </p>
                        </div>

                        {/* Instrucoes */}
                        <h3 style={{
                            color: colors.white,
                            fontSize: "0.9rem",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "2px",
                            marginBottom: "16px",
                            textAlign: "center",
                        }}>
                            Proximos Passos
                        </h3>

                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {/* Passo 1 */}
                            <div style={{
                                background: colors.bgCardLight,
                                borderRadius: "10px",
                                padding: "16px",
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "12px",
                                border: `1px solid ${colors.border}`,
                            }}>
                                <div style={{
                                    background: colors.red,
                                    borderRadius: "50%",
                                    width: "32px",
                                    minWidth: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <FaClipboardList size={14} color={colors.white} />
                                </div>
                                <div>
                                    <p style={{
                                        color: colors.white,
                                        fontWeight: 700,
                                        fontSize: "0.85rem",
                                        margin: "0 0 4px 0",
                                    }}>
                                        Acompanhe sua inscricao
                                    </p>
                                    <p style={{
                                        color: colors.gray,
                                        fontSize: "0.8rem",
                                        margin: "0 0 10px 0",
                                        lineHeight: 1.4,
                                    }}>
                                        Verifique o status da sua inscricao a qualquer momento.
                                    </p>
                                    <a
                                        href="/profile/subscription"
                                        style={{
                                            display: "inline-block",
                                            background: colors.white,
                                            color: colors.bgDark,
                                            padding: "6px 16px",
                                            borderRadius: "8px",
                                            textDecoration: "none",
                                            fontSize: "0.8rem",
                                            fontWeight: 700,
                                            transition: "opacity 0.3s",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
                                        onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                                    >
                                        Minhas Inscricoes
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Divider */}
                        <div style={{
                            height: "1px",
                            background: colors.border,
                            margin: "32px 0",
                        }} />

                        {/* Instagram CTA - Destaque */}
                        <div style={{
                            background: "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
                            borderRadius: "16px",
                            padding: "3px",
                        }}>
                            <div style={{
                                background: colors.bgCard,
                                borderRadius: "14px",
                                padding: "28px 20px",
                                textAlign: "center",
                            }}>
                                <div style={{
                                    background: "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
                                    width: "64px",
                                    height: "64px",
                                    borderRadius: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 16px",
                                }}>
                                    <FaInstagram size={34} color={colors.white} />
                                </div>
                                <p style={{
                                    color: colors.white,
                                    fontSize: "1.1rem",
                                    fontWeight: 800,
                                    margin: "0 0 6px 0",
                                    textTransform: "uppercase",
                                    letterSpacing: "1px",
                                }}>
                                    Siga-nos no Instagram
                                </p>
                                <p style={{
                                    color: colors.gray,
                                    fontSize: "0.85rem",
                                    margin: "0 0 20px 0",
                                    lineHeight: 1.5,
                                }}>
                                    Fique por dentro de chaves, resultados e novidades!
                                </p>
                                <a
                                    href="https://www.instagram.com/torneiofacil"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        background: "linear-gradient(45deg, #833ab4, #fd1d1d, #fcb045)",
                                        color: colors.white,
                                        padding: "14px 32px",
                                        borderRadius: "50px",
                                        textDecoration: "none",
                                        fontSize: "1.1rem",
                                        fontWeight: 800,
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                        boxShadow: "0 4px 20px rgba(131, 58, 180, 0.4)",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "scale(1.05)";
                                        e.currentTarget.style.boxShadow = "0 6px 25px rgba(131, 58, 180, 0.6)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(131, 58, 180, 0.4)";
                                    }}
                                >
                                    <FaInstagram size={22} />
                                    @torneiofacil
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer marca */}
                <p style={{
                    textAlign: "center",
                    color: colors.gray,
                    fontSize: "0.75rem",
                    marginTop: "24px",
                    opacity: 0.6,
                }}>
                    mais torneios, menos complicacao
                </p>
            </div>
        </div>
    );
};

export default PaymentEnrollmentICampeonatoAmazonenseDeMmaAmador2026;
